const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  linepay ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder-pay/linepay', params)
  },
  // 街口支付入口
  jkpayEntry ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder-pay/jkpay-entry', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
